import { render, staticRenderFns } from "./PtspMerchants.vue?vue&type=template&id=5bf1a7c4&scoped=true"
import script from "./PtspMerchants.vue?vue&type=script&lang=js"
export * from "./PtspMerchants.vue?vue&type=script&lang=js"
import style0 from "./PtspMerchants.vue?vue&type=style&index=0&id=5bf1a7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1a7c4",
  null
  
)

export default component.exports